import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportRoutingModule } from './reports-routing.module';
import { EmbedReportComponent } from './embed-report/embed-report.component';
import {
  MsalModule,
  MsalService,
  MsalGuard,
  MsalInterceptor,
  MsalBroadcastService,
  MsalRedirectComponent
} from '@azure/msal-angular';
import { PublicClientApplication, InteractionType, BrowserCacheLocation } from '@azure/msal-browser';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { DynamicReportComponent } from './dynamic-report/dynamic-report.component';
import { MatTabsModule } from '@angular/material/tabs';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule } from '@angular/material/menu';
import { MatChipsModule } from '@angular/material/chips';
import { FormsModule } from '@angular/forms';
import { SharedComponentsModule } from '../shared/shared-components.module';
import { InbuiltReportV2Component } from './inbuilt-report-v2/inbuilt-report-v2/inbuilt-report-v2.component';
import { InbuiltMatrixV2Component } from './inbuilt-report-v2/inbuilt-matrix-v2/inbuilt-matrix-v2.component';
import { InbuiltPagesV2Component } from './inbuilt-report-v2/inbuilt-pages-v2/inbuilt-pages-v2.component';
import { InbuiltTableV2Component } from './inbuilt-report-v2/inbuilt-table-v2/inbuilt-table-v2.component';
import { InbuiltUtilityService } from './inbuilt-report-v2/inbuilt-utility.service';
import {InbuiltFiltersV2Component} from './inbuilt-report-v2/inbuilt-filters-v2/inbuilt-filters-v2.component';
import { InbuiltCardV2Component } from './inbuilt-report-v2/inbuilt-card-v2/inbuilt-card-v2.component';
import { CompactCurrencyPipe } from './inbuilt-report-v2/inbuilt-card-v2/compact-currency.pipe';
import { InbuiltHeaderV2Component } from './inbuilt-report-v2/inbuilt-donut-v2/inbuilt-donut-v2.component';
import { InbuiltBarChartV2Component } from './inbuilt-report-v2/inbuilt-bar-chart-v2/inbuilt-bar-chart-v2.component';
import { ColumnChartV2Component } from './inbuilt-report-v2/column-chart-v2/column-chart-v2.component';
import { InbuiltVisualWrapperV2Component } from './inbuilt-report-v2/inbuilt-visual-wrapper-v2/inbuilt-visual-wrapper-v2.component';
import { InbuiltSpeedometerV2Component } from './inbuilt-report-v2/inbuilt-speedometer-v2/inbuilt-speedometer-v2.component';
import { InbuiltStatCardComponent } from './inbuilt-report-v2/inbuilt-stat-card/inbuilt-stat-card.component';
import { InbuiltDrillDownMatrixComponent } from './inbuilt-report-v2/inbuilt-drill-down-matrix/inbuilt-drill-down-matrix.component';
import { ParentChildTableComponent } from './inbuilt-report-v2/parent-child-table/parent-child-table.component';
import { InbuiltDonutChartComponent } from './inbuilt-report-v2/inbuilt-donut-chart/inbuilt-donut-chart.component';
import { InbuiltStackChartComponent } from './inbuilt-report-v2/inbuilt-stack-chart/inbuilt-stack-chart.component';
import { AppModalModule } from '../shared/elements/app-modal/app-modal.module';
import { InbuiltCustomReportComponent } from './inbuilt-report-v2/inbuilt-custom-report/inbuilt-custom-report.component';
import { InbuiltDatasourceComponent } from './inbuilt-report-v2/inbuilt-custom-report/inbuilt-datasource/inbuilt-datasource.component';
import { InbuiltFilterComponent } from './inbuilt-report-v2/inbuilt-custom-report/inbuilt-filter/inbuilt-filter.component';
import { InbuiltVisualComponent } from './inbuilt-report-v2/inbuilt-custom-report/inbuilt-visual/inbuilt-visual.component';
import { SelectDatasourceModalComponent } from './inbuilt-report-v2/inbuilt-custom-report/select-datasource-modal/select-datasource-modal.component';
import { DatasetCardComponent } from './inbuilt-report-v2/inbuilt-custom-report/select-datasource-modal/dataset-card/dataset-card.component';
import { DatasetColumnTableComponent } from './inbuilt-report-v2/inbuilt-custom-report/select-datasource-modal/dataset-column-table/dataset-column-table.component';
import { RequireDatasourceModalComponent } from './inbuilt-report-v2/inbuilt-custom-report/require-datasource-modal/require-datasource-modal.component';
import { AddFilterComponent } from './inbuilt-report-v2/inbuilt-custom-report/add-filter/add-filter.component';
import { AddFilterModalComponent } from './inbuilt-report-v2/inbuilt-custom-report/add-filter-modal/add-filter-modal.component';
import { AddVisualModalComponent } from './inbuilt-report-v2/inbuilt-custom-report/add-visual-modal/add-visual-modal.component';
import { GlobalFilterModalComponent } from './inbuilt-report-v2/inbuilt-custom-report/global-filter-modal/global-filter-modal.component';
import { DragDropModule } from '@angular/cdk/drag-drop';

@NgModule({
  declarations: [EmbedReportComponent,DynamicReportComponent, InbuiltReportV2Component, InbuiltMatrixV2Component, InbuiltPagesV2Component, InbuiltTableV2Component, InbuiltFiltersV2Component, InbuiltCardV2Component, CompactCurrencyPipe, InbuiltHeaderV2Component, InbuiltBarChartV2Component, ColumnChartV2Component, InbuiltVisualWrapperV2Component, InbuiltSpeedometerV2Component, InbuiltStatCardComponent, InbuiltDrillDownMatrixComponent, ParentChildTableComponent, InbuiltStackChartComponent, InbuiltCustomReportComponent, InbuiltDatasourceComponent, InbuiltFilterComponent, InbuiltVisualComponent, SelectDatasourceModalComponent, DatasetCardComponent, DatasetColumnTableComponent, RequireDatasourceModalComponent, AddFilterComponent, AddFilterModalComponent, AddVisualModalComponent, GlobalFilterModalComponent],
  imports: [
    CommonModule,
    MatTabsModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    SharedComponentsModule,
    InbuiltDonutChartComponent,
    ReportRoutingModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatMenuModule,
    MatChipsModule,
    AppModalModule,
    DragDropModule,
    MsalModule.forRoot(
      new PublicClientApplication({
        // MSAL Configuration
        auth: {
          clientId: environment.clientId,
          authority: environment.authorityUrl,
          redirectUri: window.location.origin + '/reports'
        },
        cache: {
          cacheLocation: BrowserCacheLocation.LocalStorage,
          storeAuthStateInCookie: true // set to true for IE 11
        },
        system: {
          loggerOptions: {
            loggerCallback: () => {},
            piiLoggingEnabled: false
          }
        }
      }) as any,
      {
        interactionType: InteractionType.Redirect // MSAL Guard Configuration
      },
      {
        interactionType: InteractionType.Redirect,
        protectedResourceMap: new Map()
      }
    )
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
    InbuiltUtilityService
  ],
  exports: [InbuiltReportV2Component, InbuiltCustomReportComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [MsalRedirectComponent]
})
export class ReportModule {}
